<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Header (fixed at top) — main or secondary depending on route -->
@if (headerState.isSecondary()) {
    <ph-secondary-header
        [titleKey]="headerState.titleKey()!"
        class="fixed w-full z-99999"
    ></ph-secondary-header>
} @else {
    <ph-header
        [showMenuToggle]="false"
        (menuToggle)="onMenuToggle()"
        class="fixed w-full z-99999"
    ></ph-header>
}

<!-- Wrapper: remove bottom padding when bottom nav is hidden -->
<main
    id="main-content"
    class="flex h-dvh w-full min-w-0 flex-col pt-13"
    [class.pb-16]="!headerState.isSecondary()"
>
    <!-- Content area: each component manages its own scroll -->
    <div class="flex min-h-0 flex-1 flex-col overflow-hidden">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        @if (true) {
            <router-outlet></router-outlet>
        }
    </div>
</main>

<!-- Bottom Navigation — hidden on secondary screens -->
@if (!headerState.isSecondary()) {
    <bottom-navigation></bottom-navigation>
}

<!-- Account Drawer (global, renders over everything) -->
<ph-account-drawer></ph-account-drawer>
